<template>
  <a @click="url" target="_blank" class="icon is-large">
    <fa :icon="['fab', 'facebook']" size="2x" />
  </a>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      message: 'socialMessage',
    }),
    path() {
      return window.location.href;
    },
  },
  methods: {
    url() {
      window.open(`https://www.facebook.com/share.php?u=${this.path}&quote=${this.message}`, "pop", "width=600, height=400, scrollbars=no");
    }
  },
};
</script>
